import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const WorkflowConfirmDialog = props => (

  <Dialog
    open={props.open}
  >
    <DialogTitle id="alert-dialog-title"> {I18n.t('application.confirm')} </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {I18n.t('messages.confirm_workflow_incomplete')}
        <br/>
        <small>{I18n.t('messages.confirm_workflow_incomplete_message')}</small>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => props.onClose(false)} >
        {I18n.t('application.no')}
      </Button>
      <Button onClick={() => props.onClose(true)} color="primary" autoFocus>
        {I18n.t('application.yes')}
      </Button>
    </DialogActions>
  </Dialog>
);

WorkflowConfirmDialog.PropTypes = {
  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default WorkflowConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowConfirmDialog.js